import React from 'react'
import { Link, graphql, StaticQuery } from 'gatsby'

function CustomLinks({ links }) {
	return (
		<div className="custom-links text-center">
			{links.map(({ label, slug }) => (
				<Link to={slug}>{label}</Link>
			))}
		</div>
	)
}

const customLinksQuery = graphql`
	{
		allSite {
			nodes {
				siteMetadata {
					themeOptions {
						site {
							customLinks {
								slug
								label
							}
						}
					}
				}
			}
		}
	}
`

function StaticCustomLinks() {
	return (
		<StaticQuery
			query={customLinksQuery}
			render={data => (
				<CustomLinks
					links={
						data.allSite.nodes[0].siteMetadata.themeOptions.site.customLinks
					}
				/>
			)}
		/>
	)
}

export default StaticCustomLinks
